import * as React from 'react'

import { ReadAloudContent } from '../../../Shared/components/readAloud/readAloudContent'
import { staticStringSource } from '../../../Shared/libs/speech/clipSource'
import useModalAccessibility from '../../../Shared/hooks/useModalAccessibility'

interface EarlySubmitModalProps {
  closeModal: any,
  requiredEditCount: number
}

const EarlySubmitModal = ({ closeModal, requiredEditCount, }: EarlySubmitModalProps) => {
  const { modalRef } = useModalAccessibility(closeModal);

  return (
    <div
      aria-labelledby='title'
      aria-live="polite"
      aria-modal={true}
      className="early-submit-modal-container"
      ref={modalRef}
      role="dialog"
      tabIndex={-1}
    >
      <div className="early-submit-modal-background" />
      <div className="early-submit-modal">
        <div className="top-section">
          <ReadAloudContent label="Read the message aloud" source={staticStringSource('proofreader.earlySubmitModal', requiredEditCount)}><h1 id="title">Keep looking! You must make at least {requiredEditCount} edits.</h1></ReadAloudContent>
          <button className="quill-button medium green contained focus-on-light" onClick={closeModal} type="button">Close</button>
        </div>
      </div>
    </div>
  )
}

export default EarlySubmitModal
